import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    attendance: [],
}

const attendanceSlice = createSlice({
    name: 'attendance',
    initialState,
    reducers: {
        allAttendance: (state, action)=>{
            state.attendance = action.payload
        },
    }
})

export const handleAttendance = (state)=>{
    return dispatch => {
        dispatch(attendanceSlice.actions.allAttendance(state))
    }
}


export default attendanceSlice.reducer